import React, { useRef } from 'react'
import { CSSTransition } from 'react-transition-group'
import cn from 'classnames'

import styles from './index.module.css'
import type { CommonBackdropProps } from './typing'

export const Backdrop = ({
  open = false,
  children,
  className,
  transitionClassname = styles,
  onClose,
  ...restProps
}: CommonBackdropProps) => {
  const nodeRef = useRef(null)

  return (
    <CSSTransition
      timeout={200}
      unmountOnExit
      classNames={transitionClassname}
      in={open}
      appear
      nodeRef={nodeRef}
      {...restProps}
    >
      <div ref={nodeRef} aria-hidden onClick={onClose} className={cn(styles.backdrop, className)}>
        {children}
      </div>
    </CSSTransition>
  )
}
